module.exports = __webpack_public_path__ + "static/media/single.413021b0.png";